/** Published when a configured screen closes, so lists showing its records can refresh. */
export const APP_UI_SCREEN_CLOSED = 'appUi:screenClosed';
